<template>
	<div id="org_register">
		<van-cell-group style="width: 95%;margin: 10px 2.5%;">
			<van-field v-model="orgName" required clearable label="组织名称" placeholder="请输入组织名称" />
			<van-field v-model="organizationCode" required clearable label="机构代码" placeholder="请输入机构代码" />
			<van-field v-model="area" required clearable label="机构地区" placeholder="选择地区" @focus="select" />
			<van-field v-model="linkman" required clearable label="负责人" placeholder="真实姓名" />
			<van-field v-model="leaderCellphone" required clearable label="手机号码" placeholder="请输入手机号码" />
			<van-field v-model="leaderEmail" clearable label="邮箱地址" placeholder="请输入邮箱地址" />
			<van-field v-model="address" required clearable label="详细地址" placeholder="请输入详细地址" />
			<van-radio-group v-model="orgRecord">
				<span class="van-radio-lable">登记状态</span>
				<van-radio name="法人组织">法人组织</van-radio>
				<van-radio name="非法人组织">非法人组织</van-radio>
			</van-radio-group>
			<van-field style="height: 0px;padding: 1px;" />
			<van-radio-group>
				<span class="van-radio-lable" style="margin-left: 2%;"><span style="color: red;">*</span>服务类别</span>
				<select v-model="serviceType" style="background: white;border: 0px;pause: 20px; box-shadow: 12;">
					<option v-for="(item,index) in columns" selected="selected">{{item}}</option>
				</select>
			</van-radio-group>
			<van-field style="height: 0px;padding: 1px;" />
			<van-radio-group>
				<span class="van-radio-lable" style="margin-left: 2%;margin-right: 20px;"><span style="color: red;">*</span>主管单位</span>
				<el-tree :data="data" :props="defaultProps" accordion @node-click="handleNodeClick">
				</el-tree>
			</van-radio-group>

			<van-field style="height: 0px;padding: 1px;" />
			<van-radio-group>
				<span class="van-radio-lable">申请理由</span>
				<el-input type="textarea" :autosize="{ minRows: 2}" placeholder="申请理由" v-model="reason">
				</el-input>
			</van-radio-group>
			<van-field style="height: 0px;padding: 1px;" />
			<van-radio-group>
				<span class="van-radio-lable">机构证件</span>
				<el-upload class="upload-demo" :action="UploadPath" name="file" :on-change="handleChange" :on-preview="handlePreview" :on-remove="handleRemove" :file-list="fileList" list-type="picture">
					<el-button size="small" type="primary">点击上传</el-button>
				</el-upload>
			</van-radio-group>
		</van-cell-group>
		<van-popup v-model="show" position="bottom" style="top:50%">
			<van-area :area-list="areaList" @confirm='confirm' @cancel='cancel' :visible-item-count="7" />
		</van-popup>
		<van-button @click="ajax" size="large" style="width: 95%;margin: 10px 2.5%;background-color: orangered;border-radius: 5px;color: white;">提交申请</van-button>
	</div>
</template>

<script>
	import { Field, Cell, CellGroup, Button, Notify, RadioGroup, Radio, Checkbox, CheckboxGroup, Area, Popup, Toast } from 'vant';
	import global from '@/api/global';
	import axios from 'axios';
	import Vue from 'vue';
	import VueCookies from 'vue-cookies';
	import areaList from '@/js/area.js';
	Vue.use(VueCookies);
	export default {
		components: {
			[Field.name]: Field,
			[Cell.name]: Cell,
			[CellGroup.name]: CellGroup,
			[Button.name]: Button,
			[Notify.name]: Notify,
			[RadioGroup.name]: RadioGroup,
			[Radio.name]: Radio,
			[Checkbox.name]: Checkbox,
			[CheckboxGroup.name]: CheckboxGroup,
			[Popup.name]: Popup,
			[Area.name]: Area,
			[Toast.name]: Toast
		},
		computed: {
			UploadPath: function() {
				return global.baseURL + 'base/uploadfile';
			}
		},
		data() {
			return {
				data: [],
				defaultProps: {
					children: 'children',
					label: 'label'
				},
				orgName: "", //组织名称
				organizationCode: "", //组织代码
				volunteerCorps: "", //地区代码
				leaderCellphone: "", //负责人号码
				leaderEmail: "", //电子邮箱
				fileList: [], //文件列表
				address: "", //详细地址
				dialogImageUrl: '',
				dialogVisible: false,
				reason: "", //申请理由
				orgRecord: "法人组织", //登记状态
				areaList,
				show: false,
				linkman: "", //负责人姓名
				area: "", //地区名称
				oid: 0, //主管部门
				serviceType: "", //服务类型
				columns: []
			}
		},
		created() {
			this.getOid();
			this.getType();
		},
		methods: {
			checkForm() {
				if(this.orgName == "") {
					Toast("组织名称不能为空");
					return false;
				}
				if(this.organizationCode == "") {
					Toast("机构代码不能为空");
					return false;
				}
				if(this.volunteerCorps == "") {
					Toast("机构地区不能为空");
					return false;
				}
				if(this.linkman == "") {
					Toast("负责人姓名不能为空");
					return false;
				}
				if(!this.isPoneAvailable(this.leaderCellphone)) {
					return false;
				}
				if(this.address == "") {
					Toast("详细地址不能为空");
					return false;
				}
				if(this.serviceType == "") {
					Toast("服务类别不能为空");
					return false;
				}
				if(this.oid == 0) {
					Toast("主管单位不能为空");
					return false;
				}
				return true;
			},
			//手机验证
			isPoneAvailable(str) {
				var myreg = /^[1][3,4,5,7,8][0-9]{9}$/;
				if(!myreg.test(str)) {
					Toast("手机格式错误");
					return false;
				} else {
					return true;
				}
			},
			//获取服务类型
			getType() {
				axios({
					method: 'get',
					url: global.baseURL + 'appsite/dictionary/selectList?type=type_zhfy'
				}).then((resp) => {
					var columns = resp.data.list;
					for(var i = 0; i < columns.length; i++) {
						this.columns.push(columns[i].name);
					}
				}).catch(resp => {
					Toast.clear();
					Toast.fail('请求失败');
				});
			},
			ajax() {
				if(!this.checkForm()) {
					return false;
				}
				var str = "";
				for(var i = 0; i < this.fileList.length; i++) {
					str += this.fileList[i].response.fileName;
					if(i != this.fileList.length - 1) {
						str += ",";
					}
				}
				Toast.loading({
					mask: true,
					message: '正在提交...',
					duration: 0
				});
				axios({
					method: 'post',
					url: global.baseURL + 'appsite/orgform/OrgRegister',
					params: {
						orgName: this.orgName,
						organizationCode: this.organizationCode,
						volunteerCorps: this.volunteerCorps,
						linkman: this.linkman,
						leaderCellphone: this.leaderCellphone,
						leaderEmail: this.leaderEmail,
						address: this.address,
						orgRecord: this.orgRecord,
						serviceType: this.serviceType,
						oid: this.oid,
						reason: this.reason,
						recordCertificate: str,
						regulatorArea: this.area,
						"auth_token": this.$cookies.get("auth_token")
					}
				}).then((resp) => {
					if(resp.data.status == 1) {
						Toast.success('已提交注册申请,待审核中');
						setTimeout(() => {
							this.run('/my_org_list');
						}, 1000);
					} else {
						Toast.fail(resp.data.msg);
					}
				}).catch(resp => {
					Toast.clear();
					Toast.fail('请求失败');
				});
			},
			getOid() { //获取
				Toast.loading({
					mask: true,
					message: '加载中...',
					duration: 0
				});
				axios({
					method: 'get',
					url: global.baseURL + 'appsite/orgform/selectByTree',
					params: {}
				}).then((resp) => {
					var list = resp.data;
					var b = {};
					var array = [];
					var oid = 0;
					for(var i = 0; i < list.length; i++) {
						b[list[i].id] = {
							label: list[i].orgName,
							id: list[i].id,
							content: list[i],
							children: []
						};
					}
					for(var id in b) {
						//console.log("属性：" + id + ",值：" + b[id]);
						if(b[id].content.oid!=0){
							//console.log(b[id].content.oid)
							b[b[id].content.oid].children.push(b[id]);
						}
					}
					var c = [];
					for(var id in b) {
						//console.log("属性：" + id + ",值：" + b[id]);
						if(b[id].content.oid==0){
							//console.log(b[id].content.oid)
							//b[b[id].content.oid].children.push(b[id]);
							c.push(b[id]);
						}
					}
					console.log(c);
					this.data = c;
					Toast.clear();
				}).catch(resp => {
					Toast.clear();
					Toast.fail('请求失败');
				});
			},
			//树形点击事件
			handleNodeClick(data) {
				Toast('你选择了 ' + data.label);
				this.oid = data.id;
			},
			//删除文件
			handleRemove(file, fileList) {
				console.log(file, fileList);
			},
			handlePreview(file) {
				console.log(file);
			},
			handleChange(file, fileList) {
				this.fileList = fileList;
			},
			//取消地区弹出层
			cancel() {
				this.show = false;
			},
			//选择地区
			confirm(e) {
				if(e[1] == null) {
					this.area = e[0].name;
					this.show = false;
					this.volunteerCorps = e[0].code;
				} else if(e[2] == null) {
					this.area = e[0].name + "-" + e[1].name;
					this.show = false;
					this.volunteerCorps = e[1].code;
				} else {
					this.area = e[0].name + "-" + e[1].name + "-" + e[2].name;
					this.show = false;
					this.volunteerCorps = e[2].code;
				}
			},
			//地区弹出层
			select() {
				this.show = true;
			},
			//跳转
			run(p) {
				this.$router.push({
					path: p
				});
			}
		}
	}
</script>

<style>
	#org_register .el-dropdown-link {
		cursor: pointer;
		color: #409EFF;
	}
	
	#org_register .el-icon-arrow-down {
		font-size: 12px;
	}
	
	#org_register * {
		font-size: 14px;
	}
	
	#org_register .van-radio-lable {
		margin-top: 10px;
		min-width: 58px;
		text-align: center;
		font-size: 14px;
		margin-right: 40px;
		margin-left: 4%;
	}
	
	#org_register .van-radio-group {
		min-height: 44px;
		display: flex;
		height: auto;
	}
	
	#org_register .van-radio {
		margin-top: 10px;
		flex: 1;
		max-width: 30%;
	}
	
	#org_register textarea {
		margin: 10px 0px;
	}
	
	#org_register .el-upload-list__item-name {
		display: none;
	}
	
	#org_register .el-upload-list__item {
		max-width: 250px;
	}
	
	#org_register .el-tree-node {
		margin: 10px;
		margin-left: 0px;
	}
	
	#org_register .upload-demo {
		margin: 10px 0px;
		flex: 1;
	}
	
	#org_register .van-field__label {
		margin-right: 6px;
	}
</style>